var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "select-message" }, [
    _vm.maximumNumberOfSelectableElements >= _vm.checkboxes.length
      ? _c(
          "button",
          {
            staticClass: "select-all-button",
            attrs: { type: "button" },
            on: { click: _vm.clickSelectAll },
          },
          [_c("strong", [_vm._v(_vm._s(_vm.selectAllTitle))])]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("form", { staticClass: "select-message-form" }, [
      _c(
        "div",
        { staticClass: "select-message-form-checkboxes" },
        [
          _vm._l(_vm.checkboxes, function (checkbox, index) {
            return _c(
              "label",
              {
                key: index,
                staticClass: "cc-checkbox-container",
                class: { disabled: _vm.disabled(checkbox) },
                attrs: { for: "checkbox" + index },
              },
              [
                _vm._v("\n        " + _vm._s(checkbox.title) + "\n        "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedUUIDs,
                      expression: "selectedUUIDs",
                    },
                  ],
                  attrs: {
                    id: "checkbox" + index,
                    type: "checkbox",
                    name: "checkbox" + index,
                    disabled: _vm.disabled(checkbox),
                  },
                  domProps: {
                    value: checkbox.uuid,
                    checked: Array.isArray(_vm.selectedUUIDs)
                      ? _vm._i(_vm.selectedUUIDs, checkbox.uuid) > -1
                      : _vm.selectedUUIDs,
                  },
                  on: {
                    click: _vm.removeNoneFromSelectedValues,
                    change: function ($event) {
                      var $$a = _vm.selectedUUIDs,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = checkbox.uuid,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.selectedUUIDs = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.selectedUUIDs = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.selectedUUIDs = $$c
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "checkmark" }),
              ]
            )
          }),
          _vm._v(" "),
          _vm.isNoneOptionEnabled
            ? _c(
                "label",
                {
                  key: "none",
                  staticClass: "cc-checkbox-container",
                  attrs: { for: "checkbox-none" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.selectNoneOptionTitle) +
                      "\n        "
                  ),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedUUIDs,
                        expression: "selectedUUIDs",
                      },
                    ],
                    attrs: {
                      id: "checkbox-none",
                      type: "checkbox",
                      name: "checkbox-none",
                      disabled: _vm.isNoneSelected,
                    },
                    domProps: {
                      value: null,
                      checked: Array.isArray(_vm.selectedUUIDs)
                        ? _vm._i(_vm.selectedUUIDs, null) > -1
                        : _vm.selectedUUIDs,
                    },
                    on: {
                      click: _vm.selectNone,
                      change: function ($event) {
                        var $$a = _vm.selectedUUIDs,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.selectedUUIDs = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.selectedUUIDs = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.selectedUUIDs = $$c
                        }
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "checkmark" }),
                ]
              )
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "quick-reply-button",
          attrs: { type: "button", disabled: _vm.selectedUUIDs.length === 0 },
          on: { click: _vm.submitCheckboxes },
        },
        [_vm._v("\n      " + _vm._s(_vm.message.content.title) + "\n    ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }